export const mapStateToProps = ({
  subscribe: { selectedPlan: subsciptionPlan, visited: subscriptionPageVisited },
}) => ({
  subsciptionPlan,
  subscriptionPageVisited,
})

export const handlers = (EVENTS) => ({
  visitSubscription:
    ({ trackEvent }) =>
    () => {
      const { name } = EVENTS.PRICING_VISIT
      trackEvent(name)
    },
  selectSubscriptionPlan:
    ({ trackEvent, subsciptionPlan }) =>
    () => {
      const { name } = EVENTS.PRICING_SELECT
      trackEvent(name, { plan: subsciptionPlan })
    },
})

export const onComponentDidUpdate = (prevProps, props) => {
  const { subsciptionPlan, subscriptionPageVisited } = props

  if (subsciptionPlan !== prevProps.subsciptionPlan) {
    props.selectSubscriptionPlan()
  }

  if (subscriptionPageVisited !== prevProps.subscriptionPageVisited && subscriptionPageVisited) {
    props.visitSubscription()
  }
}
